// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__225fS","choiceBoxes":"toolbarselects_choiceBoxes__1zBKt","simpleField":"toolbarselects_simpleField__3I6ko"};